import { makeAutoObservable } from "mobx";
import { SearchObject } from "app/common/Model/SearchObject";
import { toast } from "react-toastify";
import { PageResponse } from "app/common/Model/Shared";
import {
  searchByPageDrugOrderSync
} from "app/services/DrugService";
import { removeProduct } from "app/services/SyncCRMService";

export default class ProductVoidedAsyncStore {
  searchRegisterProduct = {
    ...new SearchObject(),
    fromLastDateSync: new Date(new Date().setMonth(new Date().getMonth() - 1)),
    toLastDateSync: new Date(),
    departmentId: null,
    isSyncedToCRM: false,
    voided: true
  };
  selectProductAsync = [];
  resetSelectedRows = false;

  pageRegisterProduct = new PageResponse();

  constructor() {
    makeAutoObservable(this);
  }

  pagingRegisterProduct = async () => {
    let { ...ortherData } = this.searchRegisterProduct;
    return await searchByPageDrugOrderSync({ ...ortherData, voided: true })
      .then(({ data }) => {
        this.pageRegisterProduct = data;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu sản phẩm có lỗi");
      });
  };

  setSelectProductAsync = (list) => {
    this.selectProductAsync = list;
  };

  removeListProductToCrm = async () => {
    const productIds = this.selectProductAsync?.map((el) => el?.id);
    this.resetSelectedRows = !this.resetSelectedRows;
    return await removeProduct(productIds)
      .then(({ data }) => {
        this.resetSelectedRows = !this.resetSelectedRows;
        this.selectProductAsync = [];
        if (Array.isArray(data)) {
          const successCount = data.length;
          const total = productIds.length;
          if (successCount === total) {
            toast.success(`Đồng bộ sản phẩm thành công: ${successCount}/${total} bản ghi`);
          } else if (successCount > 0) {
            toast.warning(`Đồng bộ sản phẩm thành công một phần: ${successCount}/${total} bản ghi`);
          } else {
            toast.error("Đồng bộ sản phẩm thất bại");
          }
          this.pagingRegisterProduct();
          return data;
        } else {
          toast.error("Dữ liệu trả về từ API không hợp lệ");
          return [];
        }
      })
      .catch((error) => {
        this.resetSelectedRows = !this.resetSelectedRows;
        this.selectProductAsync = [];
        console.error(error);
        toast.error("Đồng bộ thẻ có lỗi");
        return [];
      });
  };

  handleChangeFormSearchProduct = (searchRegisterProduct) => {
    this.searchRegisterProduct = {
      ...this.searchRegisterProduct,
      ...searchRegisterProduct,
    };
    this.pagingRegisterProduct();
  };

  resetStore = () => {
    this.searchRegisterProduct = {
      ...new SearchObject(),
      fromLastDateSync: new Date(),
      toLastDateSync: new Date(new Date().setMonth(new Date().getMonth() - 1)),
      isSyncedToCRM: false,
      voided: true
    };
    this.pageRegisterProduct = new PageResponse();
  };

}
